import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getApexTheme } from '@/lib/apex-theme';

interface ApexRadialChartProps {
  height?: number;
  series: number[];
  labels: string[];
}

export const ApexRadialChart: React.FC<ApexRadialChartProps> = ({ 
  height = 300, 
  series, 
  labels
}) => {
  const options = useMemo(() => {
    const theme = getApexTheme();
    
    return {
      ...theme,
      chart: {
        ...theme.chart,
        type: 'radialBar' as const,
        height
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: '30%',
            background: 'transparent'
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: '14px',
              fontWeight: 600,
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '20px',
              fontWeight: 700,
              formatter: (val: number) => `${val.toFixed(0)}%`
            }
          },
          track: {
            background: theme.grid.borderColor,
            strokeWidth: '97%',
            margin: 5
          }
        }
      },
      labels,
      legend: {
        ...theme.legend,
        show: true,
        floating: true,
        position: 'left' as const,
        offsetX: 0,
        offsetY: 15
      }
    };
  }, [height, labels]);

  return <ReactApexChart options={options} series={series} type="radialBar" height={height} />;
};
